import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { UserRole } from '../constants/user-constants.config';
import { buildRoleRoute } from '../helper/route.helper';
import { AuthService } from '../services/auth.service';

export const unauthGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const token = auth.isLoggedIn?.();
  const role = auth.getRole?.();
 
  // ✅ If already logged in → redirect away from login
  if (token && role) {
    let route = '';
    if (role === UserRole.SITECORDINATOR) {
       route = buildRoleRoute(role, '/profile');
    }else{
       route = buildRoleRoute(role, '/profile');
    }
    
    return router.createUrlTree([route]);
  }

  // ✅ Not logged in → allow access to login
  return true;
};
